export const GET_CASE_DETAILS = 'src/components/Cases/View/action/Get_Case_Details';
export const CASE_DETAILS_SUCCESS = 'src/components/Cases/View/action/Case_Details_Success';
export const CASE_DETAILS_FAILURE = 'src/components/Cases/View/action/Case_Details_Failure';
export const getCaseDetails = (data) => {
    return {
        type: GET_CASE_DETAILS,
        data
    }
}
export const caseDetailsSuccess = (data) => {
    return {
        type: CASE_DETAILS_SUCCESS,
        data
    }
}
export const caseDetailsFailure = (data) => {
    return {
        type: CASE_DETAILS_FAILURE,
        data
    }
}

export const GET_ALL_SECTIONS = 'src/components/Cases/View/action/Get_Sections';
export const GET_SECTION_SUCCESS = 'src/components/Cases/View/action/Get_Section_Success';
export const GET_SECTION_FAILURE = 'src/components/Cases/View/action/Get_Section_Failure';

export const getAllSections = (data) => {
    return {
        type: GET_ALL_SECTIONS,
        data
    }
}
export const sectionSuccess = (data) => {
    return {
        type: GET_SECTION_SUCCESS,
        data
    }
}
export const sectionFailure = (data) => {
    return {
        type: GET_SECTION_FAILURE,
        data
    }
}

export const DOWNLOAD_SECTION_DETAILS = 'src/components/Cases/View/action/Download_Section_Details'
export const DOWNLOAD_DATA_SURVEY_DETAILS = 'src/components/Cases/View/action/Download_Data_Survey_Details'
export const DOWNLOAD_SURVEY_DETAILS = 'src/components/Cases/View/action/Download_Survey_Details'
export const DOWNLOAD_SECTION_DETAILS_SUCCESS = 'src/components/Cases/View/action/Download_Section_Details_Success'
export const DOWNLOAD_SECTION_DETAILS_FAILURE = 'src/components/Cases/View/action/Download_Section_Details_Failure'
export const DOWNLOAD_FINANCIAL_SURVEY_DETAILS = 'src/Admin/Cases/View/action/Financial_Survey_Download';
export const setSectionDownloadURL = (data) => {
    return {
        type: DOWNLOAD_SECTION_DETAILS,
        data
    }
}


export const setFinancialSurveyDownloadLink = (data) => {
    return {
        type: DOWNLOAD_FINANCIAL_SURVEY_DETAILS,
        data
    }
}

export const setDataSurveyDownloadURL = (data) => {
    return {
        type: DOWNLOAD_DATA_SURVEY_DETAILS,
        data
    }
}
export const setSurveyDownloadURL = (data) => {
    return {
        type: DOWNLOAD_SURVEY_DETAILS,
        data
    }
}
export const sectionDownloadFileSuccess = (data) => {
    return {
        type: DOWNLOAD_SECTION_DETAILS_SUCCESS,
        data
    }
}
export const sectionDownloadFileError = (data) => {
    return {
        type: DOWNLOAD_SECTION_DETAILS_FAILURE,
        data
    }
}

export const DOWNLOAD_PREDEFINED_SECTION = 'src/components/Cases/View/action/Download_Predefined_Section'
export const DOWNLOAD_PREDEFINED_SECTION_SUCCESS = 'src/components/Cases/View/action/Download_Predefined_Section_Success'
export const DOWNLOAD_PREDEFINED_SECTION_FAILURE = 'src/components/Cases/View/action/Download_Predefined_Section_Failure'
export const setpredefinedSectionDownloadURL = (data) => {
    return {
        type: DOWNLOAD_PREDEFINED_SECTION,
        data
    }
}

export const predefinedSectionDownloadSuccess = (data) => {
    return {
        type: DOWNLOAD_PREDEFINED_SECTION_SUCCESS,
        data
    }
}
export const predefinedSectionDownloadFailure = (data) => {
    return {
        type: DOWNLOAD_PREDEFINED_SECTION_FAILURE,
        data
    }
}

export const UPLOAD_SECTION_DETAILS = 'src/components/Cases/View/action/Upload_Section_Details';
export const UPLOAD_SECTION_DETAILS_SUCCESS = 'src/components/Cases/View/action/Upload_Section_Details_Success';
export const UPLOAD_SECTION_DETAILS_FAILURE = 'src/components/Cases/View/action/Upload_Section_Details_Failure';
export const sectionUpload = (data, id) => {
    return {
        type: UPLOAD_SECTION_DETAILS,
        data,
        id
    }
}
export const sectionUploadSuccess = (data) => {
    return {
        type: UPLOAD_SECTION_DETAILS_SUCCESS,
        data
    }
}
export const sectionUploadFailure = (data) => {
    return {
        type: UPLOAD_SECTION_DETAILS_FAILURE,
        data
    }
}

export const UPLOAD_PREDEFINED_SECTION = 'src/components/Cases/View/action/Upload_Predefined_Section';
export const UPLOAD_PREDEFINED_SECTION_SUCCESS = 'src/components/Cases/View/action/Upload_Predefined_Section_Success';
export const UPLOAD_PREDEFINED_SECTION_FAILURE = 'src/components/Cases/View/action/Upload_Predefined_Section_Failure';
export const predefinedSectionUpload = (data, id) => {
    return {
        type: UPLOAD_PREDEFINED_SECTION,
        data,
        id
    }
}
export const predefinedSectionUploadSuccess = (data) => {
    return {
        type: UPLOAD_PREDEFINED_SECTION_SUCCESS,
        data
    }
}
export const predefinedSectionUploadFailure = (error) => {
    return {
        type: UPLOAD_PREDEFINED_SECTION_FAILURE,
        error
    }
}


export const SHOW_SECTION_PDF = 'src/components/Cases/View/action/Show_Section_Pdf';
export const SHOW_SECTION_PDF_SUCCESS = 'src/components/Cases/View/action/Show_Section_Pdf_Success'
export const SHOW_SECTION_PDF_FAILURE = 'src/components/Cases/View/action/Show_Section_Pdf_Failure'
export const showSectionPdf = (data) => {
    return {
        type: SHOW_SECTION_PDF,
        data
    }
}
export const showSectionPdfSuccess = (data) => {
    return {
        type: SHOW_SECTION_PDF_SUCCESS,
        data
    }
}
export const showSectionPdfFailure = (data) => {
    return {
        type: SHOW_SECTION_PDF_FAILURE,
        data
    }
}


export const GET_PREDEFINED_SECTIONS = 'src/components/Cases/View/action/Get_Predefined_Sections';
export const PREDEFINED_SECTIONS_SUCCESS = 'src/components/Cases/View/action/Get_Predefined_Sections_Success';
export const PREDEFINED_SECTIONS_FAILURE = 'src/components/Cases/View/action/Get_Predefined_Sections_Failure';
export const getPredefinedSections = () => {
    return {
        type: GET_PREDEFINED_SECTIONS
    }
}

export const predefinedSectionsSuccess = (data) => {
    return {
        type: PREDEFINED_SECTIONS_SUCCESS,
        data
    }
}
export const predefinedSectionsFailure = (error) => {
    return {
        type: PREDEFINED_SECTIONS_FAILURE,
        error
    }
}

export const ADD_PREDEFINED_SECTIONS = 'src/components/Cases/View/action/Add_Predefined_Sections';
export const ADD_PREDEFINED_SECTIONS_SUCCESS = 'src/components/Cases/View/action/Add_Predefined_Sections_Success';
export const ADD_PREDEFINED_SECTIONS_FAILURE = 'src/components/Cases/View/action/Add_Predefined_Sections_Failure';
export const addPredefinedSections = (id, list) => {
    return {
        type: ADD_PREDEFINED_SECTIONS,
        id,
        list
    }
}
export const addPredefinedSectionsSuccess = (data) => {
    return {
        type: ADD_PREDEFINED_SECTIONS_SUCCESS,
        data
    }
}
export const addPredefinedSectionsFailure = (error) => {
    return {
        type: ADD_PREDEFINED_SECTIONS_FAILURE,
        error
    }
}

export const DELETE_PREDEFINED_SECTIONS = 'src/components/Cases/View/action/Delete_Predefined_Sections';
export const DELETE_PREDEFINED_SECTIONS_SUCCESS = 'src/components/Cases/View/action/Delete_Predefined_Sections_Success';
export const DELETE_PREDEFINED_SECTIONS_FAILURE = 'src/components/Cases/View/action/Delete_Predefined_Sections_Failure';
export const deletePredefinedSections = (computedreportid, computedsectionid) => {
    return {
        type: DELETE_PREDEFINED_SECTIONS,
        computedreportid,
        computedsectionid
    }
}
export const deletePredefinedSectionsSuccess = (data) => {
    return {
        type: DELETE_PREDEFINED_SECTIONS_SUCCESS,
        data
    }
}
export const deletePredefinedSectionsFailure = (error) => {
    return {
        type: DELETE_PREDEFINED_SECTIONS_FAILURE,
        error
    }
}

export const DELETE_MULTIPLE_SECTIONS = 'src/components/Cases/View/action/Delete_Multiple_Sections';
export const DELETE_MULTIPLE_SECTIONS_SUCCESS = 'src/components/Cases/View/action/Delete_Multiple_Sections_Success';
export const DELETE_MULTIPLE_SECTIONS_FAILURE = 'src/components/Cases/View/action/Delete_Multiple_Sections_Failure';
export const deleteMultipleSections = (computedreportid,multipleSectionDeleteList) => {
    return {
        type: DELETE_MULTIPLE_SECTIONS,
        computedreportid,
        multipleSectionDeleteList
    }
}
export const deleteMultipleSectionsSuccess = (data) => {
    return {
        type: DELETE_MULTIPLE_SECTIONS_SUCCESS,
        data
    }
}
export const deleteMultipleSectionsFailure = (error) => {
    return {
        type: DELETE_MULTIPLE_SECTIONS_FAILURE,
        error
    }
}


export const PUBLISH_FINAL_REPORT = 'src/components/Cases/View/action/Publish_Final_Report';
export const PUBLISH_FINAL_REPORT_SUCCESS = 'src/components/Cases/View/action/Publish_Final_Report_Success';
export const PUBLISH_FINAL_REPORT_FAILURE = 'src/components/Cases/View/action/Publish_Final_Report_Failure';

export const publishFinalReport = (id) => {
    return {
        type: PUBLISH_FINAL_REPORT,
        id
    }
}
export const publishFinalReportSuccess = (data) => {
    return {
        type: PUBLISH_FINAL_REPORT_SUCCESS,
        data
    }
}
export const publishFinalReportFailure = (error) => {
    return {
        type: PUBLISH_FINAL_REPORT_FAILURE,
        error
    }
}

export const REORDER_SECTIONS = 'src/components/Cases/View/action/Reorder_Sections';
export const REORDER_SECTIONS_SUCCESS = 'src/components/Cases/View/action/Reorder_Sections_Success';
export const REORDER_SECTIONS_FAILURE = 'src/components/Cases/View/action/Reorder_Sections_Failure';

export const reorderSections = (id, newState) => {

    return {
        type: REORDER_SECTIONS,
        newState,
        id
    };

}

export const reorderSectionsSuccess = (data) => {
    return {
        type: REORDER_SECTIONS_SUCCESS,
        data
    }
}
export const reorderSectionsFailure = (error) => {
    return {
        type: REORDER_SECTIONS_FAILURE,
        error
    }
}

export const CHANGE_REORDER_STATUS = 'src/components/Cases/View/action/Change_Reorder_Status';
export const changeReorderStatus = () => {

    return {
        type: CHANGE_REORDER_STATUS
    };

}


export const PREVIEW_REPORT = 'src/components/Cases/View/action/Preview_Report';
export const PREVIEW_REPORT_SUCCESS = 'src/components/Cases/View/action/Preview_Report_success';
export const PREVIEW_REPORT_FAILURE = 'src/components/Cases/View/action/Preview_Report_Failure';
export const previewReport = (data) => {
    return {
        type: PREVIEW_REPORT,
        data
    }
}
export const previewReportSuccess = (data) => {
    return {
        type: PREVIEW_REPORT_SUCCESS,
        data
    }
}
export const previewReportFailure = (error) => {
    return {
        type: PREVIEW_REPORT_FAILURE,
        error
    }
}

export const VIEW_PUBLISHED_REPORT = 'src/components/Cases/View/action/View_Published_Report';
export const VIEW_PUBLISHED_REPORT_SUCCESS = 'src/components/Cases/View/action/View_Published_Report_Success';
export const VIEW_PUBLISHED_REPORT_FAILURE = 'src/components/Cases/View/action/View_Published_Report_Failure';

export const viewPublishedReport = (id) => {
    return {
        type: VIEW_PUBLISHED_REPORT,
        id
    }
}
export const viewPublishedReportSuccess = (data) => {
    return {
        type: VIEW_PUBLISHED_REPORT_SUCCESS,
        data
    }
}
export const viewPublishedReportFailure = (error) => {
    return {
        type: VIEW_PUBLISHED_REPORT_FAILURE,
        error
    }
}
export const VIEW_DOWNLOADED_REPORT = 'src/components/Cases/View/action/View_Downloaded_Report';
export const VIEW_DOWNLOADED_REPORT_SUCCESS = 'src/components/Cases/View/action/View_Downloaded_Report_Success';
export const VIEW_DOWNLOADED_REPORT_FAILURE = 'src/components/Cases/View/action/View_Downloaded_Report_Failure';

export const viewDownloadedReport = (data,name) => {
    return {
        type: VIEW_DOWNLOADED_REPORT,
        data,
        name
    }
}
export const viewDownloadedReportSuccess = (data) => {
    return {
        type: VIEW_DOWNLOADED_REPORT_SUCCESS,
        data
    }
}
export const viewDownloadedReportFailure = (data) => {
    return {
        type: VIEW_DOWNLOADED_REPORT_FAILURE,
        data
    }
}


export const CLOSE_CASE = 'src/components/Cases/View/action/Close_Case';
export const CLOSE_CASE_SUCCESS = 'src/components/Cases/View/action/Close_Case_Success';
export const CLOSE_CASE_FAILURE = 'src/components/Cases/View/action/Close_Case_Failure';

export const closeCase = (id) => {
    return {
        type: CLOSE_CASE,
        id
    }
}
export const closeCaseSuccess = (data) => {
    return {
        type: CLOSE_CASE_SUCCESS,
        data
    }
}
export const closeCaseFailure = (error) => {
    return {
        type: CLOSE_CASE_FAILURE,
        error
    }
}

export const REOPEN_CASE = 'src/components/Cases/View/action/Reopen_Case';
export const REOPEN_CASE_SUCCESS = 'src/components/Cases/View/action/Reopen_Case_Success';
export const REOPEN_CASE_FAILURE = 'src/components/Cases/View/action/Reopen_Case_Failure';

export const reopenCase = (caseId, id) => {

    return {
        type: REOPEN_CASE,
        id,
        caseId
    }
}
export const reopenCaseSuccess = (data) => {
    return {
        type: REOPEN_CASE_SUCCESS,
        data
    }
}
export const reopenCaseFailure = (error) => {
    return {
        type: REOPEN_CASE_FAILURE,
        error
    }
}


export const FETCH_CASE_SCORECARD_DETAILS = 'src/components/Cases/View/action/Fetch_Case_Scorecard_Details'
export const FETCH_CASE_SCORECARD_DETAILS_SUCCESS = 'src/components/Cases/View/action/Fetch_Case_Scorecard_Details_Success'
export const FETCH_CASE_SCORECARD_DETAILS_FAILURE = 'src/components/Cases/View/action/Fetch_Case_Scorecard_Details_Failure'
export const fetchCaseScorecardDetails = (data) => {
    return {
        type: FETCH_CASE_SCORECARD_DETAILS,
        data
    }
}
export const fetchCaseScorecardDetailsSuccess = (data) => {
    return {
        type: FETCH_CASE_SCORECARD_DETAILS_SUCCESS,
        data
    }
}
export const fetchCaseScorecardDetailsFailure = (data) => {
    return {
        type: FETCH_CASE_SCORECARD_DETAILS_FAILURE,
        data
    }
}

export const RECALCULATE_SCORE = 'src/components/Cases/View/action/Recalculate_Score'
export const RECALCULATE_SCORE_SUCCESS = 'src/components/Cases/View/action/Recalculate_Score_Success';
export const RECALCULATE_SCORE_FAILURE = 'src/components/Cases/View/action/Recalculate_Score_Failure';
export const recalculateScore = (data) => {
    return {
        type: RECALCULATE_SCORE,
        data
    }
}
export const recalculateScoreSuccess = (data) => {
    return {
        type: RECALCULATE_SCORE_SUCCESS,
        data
    }
}
export const recalculateScoreFailure = (data) => {
    return {
        type: RECALCULATE_SCORE_FAILURE,
        data
    }
}

export const UPLOAD_IMAGES = 'src/components/Cases/View/action/Upload_Images'
export const UPLOAD_IMAGES_RESPONSE = 'src/components/Cases/View/action/Upload_Images_Response';
export const UPLOAD_IMAGES_RESPONSE_ERROR = 'src/components/Cases/View/action/Upload_Images_Response_Error';
export const uploadMultipleImages = (data,id) => {
    return {
        type: UPLOAD_IMAGES,
        data,
        id
    }
}
export const uploadImagesResponse = (data) => {
    return {
        type: UPLOAD_IMAGES_RESPONSE,
        data
    }
}

export const uploadImagesResponseError = (data) => {
    return {
        type: UPLOAD_IMAGES_RESPONSE_ERROR,
        data
    }
}

export const SAVE_CASE_SCORECARD_EDIT = 'src/components/Cases/View/action/Save_Case_Scorecard_Edit'
export const SAVE_CASE_SCORECARD_EDIT_SUCCESS = 'src/components/Cases/View/action/Save_Case_Scorecard_Edit_Success';
export const SAVE_CASE_SCORECARD_EDIT_FAILURE = 'src/components/Cases/View/action/Save_Case_Scorecard_Edit_Failure';
export const saveCaseScorecard = (data) => {
    return {
        type: SAVE_CASE_SCORECARD_EDIT,
        data
    }
}
export const saveCaseScorecardSuccess = (data) => {
    return {
        type: SAVE_CASE_SCORECARD_EDIT_SUCCESS,
        data
    }
}
export const saveCaseScorecardFailure = (data) => {
    return {
        type: SAVE_CASE_SCORECARD_EDIT_FAILURE,
        data
    }
}

export const SET_ACTIVE_TAB = 'src/Admin/components/Cases/View/action/Set_Active_Tab'
export const setActiveTab = (data) => {
    return {
        type: SET_ACTIVE_TAB,
        data
    }
}

export const ADD_DATA_SECTIONS = 'src/components/Cases/View/action/Add_Data_Sections';
export const ADD_DATA_SECTIONS_SUCCESS = 'src/components/Cases/View/action/Add_Data_Sections_Success';
export const ADD_DATA_SECTIONS_FAILURE = 'src/components/Cases/View/action/Add_Data_Sections_Failure';
export const addDataSections = (id, list) => {
    return {
        type: ADD_DATA_SECTIONS,
        id,
        list
    }
}
export const addDataSectionsSuccess = (data) => {
    return {
        type: ADD_DATA_SECTIONS_SUCCESS,
        data
    }
}
export const addDataSectionsFailure = (error) => {
    return {
        type: ADD_DATA_SECTIONS_FAILURE,
        error
    }
}

export const GET_DATA_SECTIONS = 'src/components/Cases/View/action/Get_Data_Sections';
export const GET_DATA_SECTIONS_SUCCESS = 'src/components/Cases/View/action/Get_Data_Sections_Success';
export const GET_DATA_SECTIONS_FAILURE = 'src/components/Cases/View/action/Get_Data_Sections_Failure';
export const getDataSections = (id) => {
    return {
        type: GET_DATA_SECTIONS,
        id
    }
}

export const getDataSectionsSuccess = (data) => {
    return {
        type: GET_DATA_SECTIONS_SUCCESS,
        data
    }
}
export const getDataSectionsFailure = (error) => {
    return {
        type: GET_DATA_SECTIONS_FAILURE,
        error
    }
}

export const DELETE_DATA_SECTIONS = 'src/components/Cases/View/action/Delete_Data_Sections';
export const DELETE_DATA_SECTIONS_SUCCESS = 'src/components/Cases/View/action/Delete_Data_Sections_Success';
export const DELETE_DATA_SECTIONS_FAILURE = 'src/components/Cases/View/action/Delete_Data_Sections_Failure';
export const deleteDataSections = (computedreportid, computedsectionid) => {
    return {
        type: DELETE_DATA_SECTIONS,
        computedreportid,
        computedsectionid
    }
}

export const deleteDataSectionsSuccess = (data) => {
    return {
        type: DELETE_DATA_SECTIONS_SUCCESS,
        data
    }
}
export const deleteDataSectionsFailure = (error) => {
    return {
        type: DELETE_DATA_SECTIONS_FAILURE,
        error
    }
}

export const GET_CORRESPONDENT_LIST = 'src/components/Cases/View/action/Get_Correspondent_List';
export const GET_CORRESPONDENT_LIST_SUCCESS = 'src/components/Cases/View/action/Get_Correspondent_List_Success';
export const GET_CORRESPONDENT_LIST_FAILURE = 'src/components/Cases/View/action/Get_Correspondent_List_Failure';
export const getCorrespondentList = (data) => {
    return {
        type: GET_CORRESPONDENT_LIST,
        data
    }
}

export const getCorrespondentListSuccess = (data) => {
    return {
        type: GET_CORRESPONDENT_LIST_SUCCESS,
        data
    }
}
export const getCorrespondentListFailure = (error) => {
    return {
        type: GET_CORRESPONDENT_LIST_FAILURE,
        error
    }
}

export const ASSIGN_TO_CORRESPONDENT = 'src/components/Cases/View/action/Assign_To_Correspondent';
export const ASSIGN_TO_CORRESPONDENT_SUCCESS = 'src/components/Cases/View/action/Assign_To_Correspondent_Success';
export const ASSIGN_TO_CORRESPONDENT_FAILURE = 'src/components/Cases/View/action/Assign_To_Correspondent_Failure';
export const assignToCorrespondent = (id, data, computedReportId) => {
    return {
        type: ASSIGN_TO_CORRESPONDENT,
        id,
        data,
        computedReportId
    }
}

export const assignToCorrespondentSuccess = (data) => {
    return {
        type: ASSIGN_TO_CORRESPONDENT_SUCCESS,
        data
    }
}
export const assignToCorrespondentFailure = (error) => {
    return {
        type: ASSIGN_TO_CORRESPONDENT_FAILURE,
        error
    }
}

export const APPROVE_SECTION = 'src/components/Cases/View/action/Approve_Section';
export const APPROVE_SECTION_SUCCESS = 'src/components/Cases/View/action/Approve_Section_Success';
export const APPROVE_SECTION_FAILURE = 'src/components/Cases/View/action/Approve_Section_Failure';
export const approveSection = (taskId, computedreportid) => {
    return {
        type: APPROVE_SECTION,
        taskId,
        computedreportid
    }
}

export const approveSectionSuccess = (data) => {
    return {
        type: APPROVE_SECTION_SUCCESS,
        data
    }
}
export const approveSectionFailure = (error) => {
    return {
        type: APPROVE_SECTION_FAILURE,
        error
    }
}

export const REJECT_SECTION = 'src/components/Cases/View/action/Reject_Section';
export const REJECT_SECTION_SUCCESS = 'src/components/Cases/View/action/Reject_Section_Success';
export const REJECT_SECTION_FAILURE = 'src/components/Cases/View/action/Reject_Section_Failure';
export const rejectSection = (taskId, computedreportid, reqbody) => {
    return {
        type: REJECT_SECTION,
        taskId,
        computedreportid,
        reqbody
    }
}

export const rejectSectionSuccess = (data) => {
    return {
        type: REJECT_SECTION_SUCCESS,
        data
    }
}
export const rejectSectionFailure = (error) => {
    return {
        type: REJECT_SECTION_FAILURE,
        error
    }
}
export const DOWNLOAD_SUBMITTED_TASK = 'src/components/Cases/View/action/Download_Submitted_Task';
export const DOWNLOAD_SUBMITTED_TASK_SUCCESS = 'src/components/Cases/View/action/Download_Submitted_Task_Success';
export const DOWNLOAD_SUBMITTED_TASK_FAILURE = 'src/components/Cases/View/action/Download_Submitted_Task_Failure';
export const downloadSubmittedTask = (data) => {
    return {
        type: DOWNLOAD_SUBMITTED_TASK,
        data
    }
}

export const downloadSubmittedTaskSuccess = (data) => {
    return {
        type: DOWNLOAD_SUBMITTED_TASK_SUCCESS,
        data
    }
}
export const downloadSubmittedTaskFailure = (error) => {
    return {
        type: DOWNLOAD_SUBMITTED_TASK_FAILURE,
        error
    }
}

export const WITHDRAW_CASE = 'src/Analyst/Cases/View/action/Withdraw_Case'
export const WITHDRAW_CASE_SUCCESS = 'src/Analyst/Cases/View/action/Withdraw_Case_Success'
export const WITHDRAW_CASE_FAILURE = 'src/Analyst/Cases/View/action/Withdraw_Case_Failure'

export const withdrawCase = (data) => {
    return {
        type: WITHDRAW_CASE,
        data
    }
}
export const withdrawCaseSuccess = (data) => {
    return {
        type: WITHDRAW_CASE_SUCCESS,
        data
    }
}
export const withdrawCaseFailure = (data) => {
    return {
        type: WITHDRAW_CASE_FAILURE,
        data
    }
}

export const FETCH_XBRL_DETAILS = 'src/Analyst/Cases/View/Fetch_Xbrl_Details';
export const FETCH_XBRL_DETAILS_SUCCESS = 'src/Analyst/Cases/View/Fetch_Xbrl_Details_Success';
export const FETCH_XBRL_DETAILS_FAILURE = 'src/Analyst/Cases/View/Fetch_Xbrl_Details_Failure';

export const fetchXbrlDetails = (data) => {
    return {
        type: FETCH_XBRL_DETAILS,
        data
    }
}
export const fetchXbrlDetailsSuccess = (data) => {
    return {
        type: FETCH_XBRL_DETAILS_SUCCESS,
        data
    }
}
export const fetchXbrlDetailsFailure = (data) => {
    return {
        type: FETCH_XBRL_DETAILS_FAILURE,
        data
    }
}

export const DOWNLOAD_XBRL_FILE = 'src/Analyst/Cases/View/Download_Xbrl_File';
export const DOWNLOAD_XBRL_FILE_SUCCESS = 'src/Analyst/Cases/View/Download_Xbrl_File_Success';
export const DOWNLOAD_XBRL_FILE_FAILURE = 'src/Analyst/Cases/View/Download_Xbrl_File_Failure';

export const downloadXbrlFile = (data) => {
    return {
        type: DOWNLOAD_XBRL_FILE,
        data
    }
}
export const downloadXbrlFileSuccess = (data) => {
    return {
        type: DOWNLOAD_XBRL_FILE_SUCCESS,
        data
    }
}
export const downloadXbrlFileFailure = (data) => {
    return {
        type: DOWNLOAD_XBRL_FILE_FAILURE,
        data
    }
}

export const UPLOAD_XBRL_FILE = 'src/Analyst/Cases/View/Upload_Xbrl_File';
export const UPLOAD_XBRL_FILE_SUCCESS = 'src/Analyst/Cases/View/Upload_Xbrl_File_Success';
export const UPLOAD_XBRL_FILE_FAILURE = 'src/Analyst/Cases/View/Upload_Xbrl_File_Failure';

export const uploadXbrlFile = (data) => {
    return {
        type: UPLOAD_XBRL_FILE,
        data
    }
}
export const uploadXbrlFileSuccess = (data) => {
    return {
        type: UPLOAD_XBRL_FILE_SUCCESS,
        data
    }
}
export const uploadXbrlFileFailure = (data) => {
    return {
        type: UPLOAD_XBRL_FILE_FAILURE,
        data
    }
}


export const RERUN_PROCESSING = 'src/Analyst/Cases/View/action/Rerun_Processing'
export const RERUN_PROCESSING_SUCCESS = 'src/Analyst/Cases/View/action/Rerun_Processing_Success'
export const RERUN_PROCESSING_FAILURE = 'src/Analyst/Cases/View/action/Rerun_Processing_Failure'

export const rerunProcessing = (data) => {
    return {
        type: RERUN_PROCESSING,
        data
    }
}
export const rerunProcessingSuccess = (data) => {
    return {
        type: RERUN_PROCESSING_SUCCESS,
        data
    }
}
export const rerunProcessingFailure = (data) => {
    return {
        type: RERUN_PROCESSING_FAILURE,
        data
    }
}

export const GET_CASE_EPF_DETAILS = 'src/components/Cases/View/action/Get_Case_EPF_Details';
export const CASE_DETAILS_EPF_SUCCESS = 'src/components/Cases/View/action/Case_Details_EPF_Success';
export const CASE_DETAILS_EPF_FAILURE = 'src/components/Cases/View/action/Case_Details_EPF_Failure';
export const getCaseEPFDetails = (data) => {
    return {
        type: GET_CASE_EPF_DETAILS,
        data
    }
}
export const caseDetailsEPFSuccess = (data) => {
    return {
        type: CASE_DETAILS_EPF_SUCCESS,
        data
    }
}
export const caseDetailsEPFFailure = (data) => {
    return {
        type: CASE_DETAILS_EPF_FAILURE,
        data
    }
}
export const FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS = 'src/components/Cases/View/action/Fetch_Case_Executive_Summary_Details'
export const FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS_SUCCESS = 'src/components/Cases/View/action/Fetch_Case_Executive_Summary_Details_Success'
export const FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS_FAILURE = 'src/components/Cases/View/action/Fetch_Case_Executive_Summary_Details_Failure'
export const fetchcaseExecutiveSummaryDetails = (computedReportId,computedSectionId,sectionaTag) => {
    return {
        type: FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS,
        computedReportId,
        computedSectionId,
        sectionaTag
    }
}
export const fetchcaseExecutiveSummaryDetailsSuccess = (data) => {
    return {
        type: FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS_SUCCESS,
        data
    }
}
export const fetchcaseExecutiveSummaryDetailsFailure = (error) => {
    return {
        type: FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS_FAILURE,
        error
    }
}

export const FETCH_FERERO_KPI_DETAILS = 'src/components/Cases/View/action/Fetch_Ferrero_Kpi_Details'
export const FETCH_FERERO_KPI_DETAILS_SUCCESS = 'src/components/Cases/View/action/Fetch_Ferrero_Kpi_Details_Success'
export const FETCH_FERERO_KPI_DETAILS_FAILURE = 'src/components/Cases/View/action/Fetch_Ferrero_Kpi_Details_Failure'
export const fetchferreroKpiDetails = (computedReportId,computedSectionId,sectionaTag) => {
    return {
        type: FETCH_FERERO_KPI_DETAILS,
        computedReportId,
        computedSectionId,
        sectionaTag
    }
}
export const fetchferreroKpiDetailsSuccess = (data) => {
    return {
        type: FETCH_FERERO_KPI_DETAILS_SUCCESS,
        data
    }
}
export const fetchferreroKpiDetailsFailure = (error) => {
    return {
        type: FETCH_FERERO_KPI_DETAILS_FAILURE,
        error
    }
}

export const GET_BSA_ENTITY_TYPES = 'src/components/Cases/View/action/Get_Bsa_Entity_Types';
export const BSA_ENTITY_TYPES_SUCCESS = 'src/components/Cases/View/action/Bsa_Entity_Types_Success';
export const BSA_ENTITY_TYPES_FAILURE = 'src/components/Cases/View/action/Bsa_Entity_Types_Failure';
export const getBsaEntityTypes = () => {
    return {
        type: GET_BSA_ENTITY_TYPES
    }
}
export const bsaEntityTypesSuccess = (data) => {
    return {
        type: BSA_ENTITY_TYPES_SUCCESS,
        data
    }
}
export const bsaEntityTypesFailure = (data) => {
    return {
        type: BSA_ENTITY_TYPES_FAILURE,
        data
    }
}

export const GET_BSA_BANK_NAMES = 'src/components/Cases/View/action/Get_Bsa_Bank_Names';
export const BSA_BANK_NAMES_SUCCESS = 'src/components/Cases/View/action/Bsa_Bank_Names_Success';
export const BSA_BANK_NAMES_FAILURE = 'src/components/Cases/View/action/Bsa_Bank_Names_Failure';
export const getBsaBankNames = () => {
    return {
        type: GET_BSA_BANK_NAMES
    }
}
export const bsaBankNamesSuccess = (data) => {
    return {
        type: BSA_BANK_NAMES_SUCCESS,
        data
    }
}
export const bsaBankNamesFailure = (data) => {
    return {
        type: BSA_BANK_NAMES_FAILURE,
        data
    }
}

export const GET_BSA_ACCOUNT_TYPES = 'src/components/Cases/View/action/Get_Bsa_Account_Types';
export const BSA_ACCOUNT_TYPES_SUCCESS = 'src/components/Cases/View/action/Bsa_Account_Types_Success';
export const BSA_ACCOUNT_TYPES_FAILURE = 'src/components/Cases/View/action/Bsa_Account_Types_Failure';
export const getBsaAccountTypes = () => {
    return {
        type: GET_BSA_ACCOUNT_TYPES
    }
}
export const bsaAccountTypesSuccess = (data) => {
    return {
        type: BSA_ACCOUNT_TYPES_SUCCESS,
        data
    }
}
export const bsaAccountTypesFailure = (data) => {
    return {
        type: BSA_ACCOUNT_TYPES_FAILURE,
        data
    }
}
export const GET_ALL_COMPUTED_SECTION_TEMPLATE = 'src/components/Cases/View/action/Get_All_Computed_Section_Template';
export const GET_ALL_COMPUTED_SECTION_TEMPLATE_SUCCESS = 'src/components/Cases/View/action/Get_All_Computed_Section_Template_Success';
export const GET_ALL_COMPUTED_SECTION_TEMPLATE_FAILURE = 'src/components/Cases/View/action/Get_All_Computed_Section_Template_Failure';
export const getAllComputedSectionTemplate = (data) => {
    return {
        type: GET_ALL_COMPUTED_SECTION_TEMPLATE,
        data
    }
}
export const getAllComputedSectionTemplateSuccess = (data) => {
    return {
        type: GET_ALL_COMPUTED_SECTION_TEMPLATE_SUCCESS,
        data
    }
}
export const getAllComputedSectionTemplateFailure = (data) => {
    return {
        type: GET_ALL_COMPUTED_SECTION_TEMPLATE_FAILURE,
        data
    }

}
export const FETCH_CASE_SCORECARD_RATIONAL_DETAILS = 'src/components/Cases/View/action/Fetch_Case_ScoreCard_Rational_Details'
export const FETCH_CASE_SCORECARD_RATIONAL_DETAILS_SUCCESS = 'src/components/Cases/View/action/Fetch_Case_ScoreCard_Rational_Details_Success'
export const FETCH_CASE_SCORECARD_RATIONAL_DETAILS_FAILURE = 'src/components/Cases/View/action/Fetch_Case_ScoreCard_Rational_Details_Failure'
export const fetchcaseScorecardRationalDetails = (computedReportId,computedSectionId) => {
    return {
        type: FETCH_CASE_SCORECARD_RATIONAL_DETAILS,
        computedReportId,
        computedSectionId
        
    }
}
export const fetchcaseScorecardRationalDetailsSuccess = (data) => {
    return {
        type: FETCH_CASE_SCORECARD_RATIONAL_DETAILS_SUCCESS,
        data
    }
}
export const fetchcaseScorecardRationalDetailsFailure = (error) => {
    return {
        type: FETCH_CASE_SCORECARD_RATIONAL_DETAILS_FAILURE,
        error
    }
}

export const FETCH_KYB_DETAILS = 'src/components/Cases/View/action/Fetch_KYB_Details';
export const FETCH_KYB_DETAILS_SUCCESS= 'src/components/Cases/View/action/Fetch_KYB_Details_Success';
export const FETCH_KYB_DETAILS_FAILURE= 'src/components/Cases/View/action/Fetch_KYB_Details_Failure';

export const fetchKybData = (data) =>{
    return {
        type: FETCH_KYB_DETAILS,
        data
    }
}

export const fetchKybDetailsSuccess = (data) => {
    return {
        type: FETCH_KYB_DETAILS_SUCCESS,
        data
    }
}
export const fetchKybDetailsFailure = (error) => {
    return {
        type: FETCH_KYB_DETAILS_FAILURE,
        error
    }
}

export const KYB_RECORD_SUBMIT = 'src/components/Cases/View/action/Kyb_Record_Submit';
export const KYB_RECORD_SUBMIT_SUCCESS= 'src/components/Cases/View/action/Kyb_Record_Submit_Success';
export const KYB_RECORD_SUBMIT_FAILURE= 'src/components/Cases/View/action/Kyb_Record_Submit_Failure';

export const kybRecordSubmit = (data) =>{
    return {
        type: KYB_RECORD_SUBMIT,
        data
    }
}

export const kybRecordSubmitSuccess = (data) => {
    return {
        type: KYB_RECORD_SUBMIT_SUCCESS,
        data
    }
}
export const kybRecordSubmitFailure = (error) => {
    return {
        type: KYB_RECORD_SUBMIT_FAILURE,
        error
    }
}

export const MARK_CASE_PENDING = 'src/Analyst/Cases/View/action/Mark_Case_Pending'
export const MARK_CASE_PENDING_SUCCESS = 'src/Analyst/Cases/View/action/Mark_Case_Pending_Success'
export const MARK_CASE_PENDING_FAILURE = 'src/Analyst/Cases/View/action/Mark_Case_Pending_Failure'

export const markCasePending = (data) => {
    return {
        type: MARK_CASE_PENDING,
        data
    }
}
export const markCasePendingSuccess = (data) => {
    return {
        type: MARK_CASE_PENDING_SUCCESS,
        data
    }
}
export const markCasePendingFailure = (data) => {
    return {
        type: MARK_CASE_PENDING_FAILURE,
        data
    }
}

export const FETCH_SCORE_BREAK_UP_DETAILS = 'src/components/Cases/View/action/Fetch_Case_ScoreBreakUp_Details'
export const FETCH_SCORE_BREAK_UP_DETAILS_SUCCESS = 'src/components/Cases/View/action/Fetch_Case_ScoreBreakUp_Details_Success'
export const FETCH_SCORE_BREAK_UP_DETAILS_FAILURE = 'src/components/Cases/View/action/Fetch_Case_ScoreBreakUp_Details_Failure'
export const fetchScoreBreakUpDetails = (computedReportId,sectiontag) => {
    return {
        type: FETCH_SCORE_BREAK_UP_DETAILS,
        computedReportId,
        sectiontag
        
    }
}
export const fetchScoreBreakUpDetailsSuccess = (data) => {
    return {
        type: FETCH_SCORE_BREAK_UP_DETAILS_SUCCESS,
        data
    }
}
export const fetchScoreBreakUpDetailsFailure = (error) => {
    return {
        type: FETCH_SCORE_BREAK_UP_DETAILS_FAILURE,
        error
    }
}

export const FETCH_SCORE_SUMMARY_DETAILS = 'src/components/Cases/View/action/Fetch_Case_ScoreSummary_Details'
export const FETCH_SCORE_SUMMARY_DETAILS_SUCCESS = 'src/components/Cases/View/action/Fetch_Case_ScoreSummary_Details_Success'
export const FETCH_SCORE_SUMMARY_DETAILS_FAILURE = 'src/components/Cases/View/action/Fetch_Case_ScoreSummary_Details_Failure'
export const fetchScoreSummaryDetails = (computedReportId,computedSectionId) => {
    return {
        type: FETCH_SCORE_SUMMARY_DETAILS,
        computedReportId,
        computedSectionId
        
    }
}
export const fetchScoreSummaryDetailsSuccess = (data) => {
    return {
        type: FETCH_SCORE_SUMMARY_DETAILS_SUCCESS,
        data
    }
}
export const fetchScoreSummaryDetailsFailure = (error) => {
    return {
        type: FETCH_SCORE_SUMMARY_DETAILS_FAILURE,
        error
    }
}


export const DOWNLOAD_ATTACHMENT_REQUEST = 'DOWNLOAD_ATTACHMENT_REQUEST';
export const DOWNLOAD_ATTACHMENT_SUCCESS = 'DOWNLOAD_ATTACHMENT_SUCCESS';
export const DOWNLOAD_ATTACHMENT_FAILURE = 'DOWNLOAD_ATTACHMENT_FAILURE';

export const downloadAttachmentRequest = (fileName) => ({
    type: DOWNLOAD_ATTACHMENT_REQUEST,
    fileName
});

export const downloadAttachmentSuccess = () => ({
    type: DOWNLOAD_ATTACHMENT_SUCCESS,
    data
});

export const downloadAttachmentFailure = (error) => ({
    type: DOWNLOAD_ATTACHMENT_FAILURE,
    error
});

